<div class="top-menu-hld center-flex">
  <div class="left-col">
    <div class="menu-hld center-flex">
      <div class="title-hld">
        <div class="logo-holder center-flex" (click)="navigateTo()">
          <div class="center-flex">
            <mat-icon svgIcon="intowords_logo"></mat-icon>
          </div>
          <div class="title">IntoWords</div>
        </div>
      </div>
    </div>
  </div>
  <div class="right-col center-flex ml-auto">
    <div class="app-menu-hld center-flex">
      @for (item of appLinks; track item) {
        <div [routerLink]="[item.url]" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }" class="app-menu-item">
          {{'translate' + item.name | translate}}
        </div>
      }
    </div>
    <div class="center-flex">
      <div class="contact-info-hld">
        {{'translateSupport' | translate}}: {{'translateContactNumber' | translate}}
      </div>
      <div class="language-hld">
        <mat-icon svgIcon="language" (click)="openLanguageModal()"></mat-icon>
      </div>
    </div>
  </div>
</div>
